import { routeConfig } from "@/routes/route";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";

const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@LeadGen/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const useQualificationRoutes = () => {
  const { t } = useTranslation();

  // 动态路由配置
  const addPages = ["icp", "trademark", "industry", "others"];
  const pageName: { [key: string]: string } = {
    main: t("account.QualificationVerification.PageNames.main"),
    icp: t("account.QualificationVerification.PageNames.icp"),
    trademark: t("account.QualificationVerification.PageNames.trademark"),
    industry: t("account.QualificationVerification.PageNames.industry"),
    others: t("account.QualificationVerification.PageNames.others")
  };
  const updatePages = [...addPages, "main"];

  const addRouters = addPages.map((page, index) => {
    return {
      path: `/leadgen_qualification/${page}/add`,
      element: LazyLoad(`Qualification/${page}`),
      name: pageName[page],
      key: "q_a_" + index + "_key",
      isHidden: true,
      fromPath: "/leadgen_qualification",
      pathReg: /\/leadgen_qualification\/[a-zA-Z]+\/add/,
    };
  });

  const updateRouters = updatePages.map((page, index) => {
    return {
      path: `/leadgen_qualification/${page}/update`,
      element: LazyLoad(`Qualification/${page}`),
      name: pageName[page],
      key: "q_d_" + index + "_key",
      isHidden: true,
      fromPath: "/leadgen_qualification",
      pathReg: /\/leadgen_qualification\/[a-zA-Z]+\/update/,
    };
  });

  return [
    {
      path: "/leadgen_qualification",
      element: LazyLoad("Qualification/list"),
      name: t("Basics.LeftMenu.QualificationVerification"),
      key: "accountManagement1",
      icon: "certificate-svg",
    },
    ...addRouters, ...updateRouters
  ];
};

// 静态路由配置（用于向后兼容）
const addPages = ["icp", "trademark", "industry", "others"];
const staticPageName: { [key: string]: string } = {
  main: "营业执照",
  icp: "ICP备案证明",
  trademark: "商标证",
  industry: "行业资质",
  others: "补充资质"
};
const updatePages = [...addPages, "main"];

const staticAddRouters = addPages.map((page, index) => {
  return {
    path: `/leadgen_qualification/${page}/add`,
    element: LazyLoad(`Qualification/${page}`),
    name: staticPageName[page],
    key: "q_a_" + index + "_key",
    isHidden: true,
    fromPath: "/leadgen_qualification",
    pathReg: /\/leadgen_qualification\/[a-zA-Z]+\/add/,
  };
});

const staticUpdateRouters = updatePages.map((page, index) => {
  return {
    path: `/leadgen_qualification/${page}/update`,
    element: LazyLoad(`Qualification/${page}`),
    name: staticPageName[page],
    key: "q_d_" + index + "_key",
    isHidden: true,
    fromPath: "/leadgen_qualification",
    pathReg: /\/leadgen_qualification\/[a-zA-Z]+\/update/,
  };
});

export const LeadGneQualificationPages: routeConfig[] = [
  {
    path: "/leadgen_qualification",
    element: LazyLoad("Qualification/list"),
    name: "资质验证",
    key: "accountManagement1",
    icon: "certificate-svg",
  },
  ...staticAddRouters, ...staticUpdateRouters
];
